export const shareOnReddit = (url, title = "") => {
  const shareUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`
  window.open(shareUrl, "reddit-share-dialog", "width=626,height=436")
}